import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import variantsSpecificationsAndFeatures from '../../graphql/variantsSpecificationsAndFeatures';
import { GetVariantsSpecificationsAndFeaturesVariables } from '../../graphql/__generated__/GetVariantsSpecificationsAndFeatures';
import { IVariants } from '../../model/IVariants';
import IParams from '../../../gqlCustomise/model/IParams';

const useVariantsSpecificationsAndFeatures = () => {
  const { trimCode } = useParams<IParams>();

  const { data, loading, error } = useQuery<IVariants, GetVariantsSpecificationsAndFeaturesVariables>(
    variantsSpecificationsAndFeatures.GET_VARIANTS_SPECIFICATIONS_AND_FEATURES,
    {
      variables: {
        filters: { trimCode },
      },
    },
  );

  return { data, loading, error };
};

export default useVariantsSpecificationsAndFeatures;
